import type { QueriesObject, QueryResults, System } from '../../odie';
import { BlockComponent } from '../components/BlockComponent';
import { CurtainBlockComponent } from '../components/CurtainBlockComponent';
import { PhaseComponent } from '../components/PhaseComponent';
import { BlockId, blockPropsMap } from '../defs/block';
import { CurtainBlockEntity } from '../entities/BlockEntity';
import type { GameScene } from '../GameScene';

/*
  Handles curtain block specifics.
*/
export class CurtainBlockSystem implements System {
  public static readonly NAME = 'blockCurtain';
  public static Queries: QueriesObject = {
    block: {
      components: [BlockComponent, CurtainBlockComponent],
    },
    phase: {
      components: [PhaseComponent],
      modified: true,
    },
  };

  public scene!: GameScene;
  public queries!: QueryResults;

  public init() {
    this.scene.events.subscribe((e) => {
      if (!e || e.id !== 'destroy') return;
      this.onBlockDestroyed(e.blockId);
    });
  }

  private onBlockDestroyed(blockId: BlockId) {
    const props = blockPropsMap[blockId];
    const blockColor = 'color' in props ? props.color : 'all';
    this.queries.block.forEach((entity: CurtainBlockEntity) => {
      const targetColor = entity.c.blockCurtain.color;

      if (targetColor === 'all' || targetColor === blockColor) {
        entity.c.block.collide('goal');
      }
    });
  }
}
